import { translateCashflowLabel } from "./cashflowLabelI18n";

export function GetHeaders(value) {
  if (!value) return value;
  const translated = translateCashflowLabel(value);
  if (translated !== value) return translated;
  return value.replaceAll("_", " ");
}
